var _____WB$wombat$assign$function_____ = function (name) {
    return (self._wb_wombat && self._wb_wombat.local_init && self._wb_wombat.local_init(name)) || self[name];
};
if (!self.__WB_pmw) {
    self.__WB_pmw = function (obj) {
        this.__WB_source = obj;
        return this;
    };
}
{
    let window = _____WB$wombat$assign$function_____("window");
    let self = _____WB$wombat$assign$function_____("self");
    let document = _____WB$wombat$assign$function_____("document");
    let location = _____WB$wombat$assign$function_____("location");
    let top = _____WB$wombat$assign$function_____("top");
    let parent = _____WB$wombat$assign$function_____("parent");
    let frames = _____WB$wombat$assign$function_____("frames");
    let opener = _____WB$wombat$assign$function_____("opener");

    (function (a) {
        if (typeof define === "function" && define.amd) {
            define(["jquery"], a);
        } else {
            a(jQuery);
        }
    })(function ($) {
        var j = ($.scrollTo = function (a, b, c) {
            return $(window).scrollTo(a, b, c);
        });
        j.defaults = { axis: "xy", duration: parseFloat($.fn.jquery) >= 1.3 ? 0 : 1, limit: true };
        j.window = function (a) {
            return $(window)._scrollable();
        };
        $.fn._scrollable = function () {
            return this.map(function () {
                var a = this,
                    isWin = !a.nodeName || $.inArray(a.nodeName.toLowerCase(), ["iframe", "#document", "html", "body"]) != -1;
                if (!isWin) return a;
                var b = (a.contentWindow || a).document || a.ownerDocument || a;
                return /webkit/i.test(navigator.userAgent) || b.compatMode == "BackCompat" ? b.body : b.documentElement;
            });
        };
        $.fn.scrollTo = function (f, g, h) {
            if (typeof g == "object") {
                h = g;
                g = 0;
            }
            if (typeof h == "function") h = { onAfter: h };
            if (f == "max") f = 9e9;
            h = $.extend({}, j.defaults, h);
            g = g || h.duration;
            h.queue = h.queue && h.axis.length > 1;
            if (h.queue) g /= 2;
            h.offset = both(h.offset);
            h.over = both(h.over);
            return this._scrollable()
                .each(function () {
                    if (f == null) return;
                    var d = this,
                        $elem = $(d),
                        targ = f,
                        toff,
                        attr = {},
                        win = $elem.is("html,body");
                    switch (typeof targ) {
                        case "number":
                        case "string":
                            if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
                                targ = both(targ);
                                break;
                            }
                            targ = $(targ, this);
                            if (!targ.length) return;
                        case "object":
                            if (targ.is || targ.style) toff = (targ = $(targ)).offset();
                    }
                    var e = ($.isFunction(h.offset) && h.offset(d, targ)) || h.offset;
                    $.each(h.axis.split(""), function (i, a) {
                        var b = a == "x" ? "Left" : "Top",
                            pos = b.toLowerCase(),
                            key = "scroll" + b,
                            old = d[key],
                            max = j.max(d, a);
                        if (toff) {
                            attr[key] = toff[pos] + (win ? 0 : old - $elem.offset()[pos]);
                            if (h.margin) {
                                attr[key] -= parseInt(targ.css("margin" + b)) || 0;
                                attr[key] -= parseInt(targ.css("border" + b + "Width")) || 0;
                            }
                            attr[key] += e[pos] || 0;
                            if (h.over[pos]) attr[key] += targ[a == "x" ? "width" : "height"]() * h.over[pos];
                        } else {
                            var c = targ[pos];
                            attr[key] = c.slice && c.slice(-1) == "%" ? (parseFloat(c) / 100) * max : c;
                        }
                        if (h.limit && /^\d+$/.test(attr[key])) attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);
                        if (!i && h.queue) {
                            if (old != attr[key]) animate(h.onAfterFirst);
                            delete attr[key];
                        }
                    });
                    animate(h.onAfter);
                    function animate(a) {
                        $elem.animate(
                            attr,
                            g,
                            h.easing,
                            a &&
                                function () {
                                    a.call(this, targ, h);
                                }
                        );
                    }
                })
                .end();
        };
        j.max = function (a, b) {
            var c = b == "x" ? "Width" : "Height",
                scroll = "scroll" + c;
            if (!$(a).is("html,body")) return a[scroll] - $(a)[c.toLowerCase()]();
            var d = "client" + c,
                html = a.ownerDocument.documentElement,
                body = a.ownerDocument.body;
            return Math.max(html[scroll], body[scroll]) - Math.min(html[d], body[d]);
        };
        function both(a) {
            return $.isFunction(a) || typeof a == "object" ? a : { top: a, left: a };
        }
        return j;
    });
    (function ($) {
        var f = ".serialScroll";
        var g = ($.serialScroll = function (a) {
            return $(window).serialScroll(a);
        });
        g.defaults = { duration: 1000, axis: "x", event: "click", start: 0, step: 1, lock: true, cycle: true, constant: true };
        $.fn.serialScroll = function (d) {
            return this.each(function () {
                var c = $.extend({}, g.defaults, d),
                    event = c.event,
                    step = c.step,
                    lazy = c.lazy,
                    context = c.target ? this : document,
                    $pane = $(c.target || this, context),
                    pane = $pane[0],
                    items = c.items,
                    active = c.start,
                    auto = c.interval,
                    nav = c.navigation,
                    timer;
                if (!pane) return;
                if (!lazy) items = getItems();
                if (c.force || auto) jump({}, active);
                $(c.prev || [], context).bind(event, -step, move);
                $(c.next || [], context).bind(event, step, move);
                if (!pane.ssbound)
                    $pane
                        .bind("prev" + f, -step, move)
                        .bind("next" + f, step, move)
                        .bind("goto" + f, jump);
                if (auto)
                    $pane
                        .bind("start" + f, function (e) {
                            if (!auto) {
                                clear();
                                auto = true;
                                next();
                            }
                        })
                        .bind("stop" + f, function () {
                            clear();
                            auto = false;
                        });
                $pane.bind("notify" + f, function (e, a) {
                    var i = index(a);
                    if (i > -1) active = i;
                });
                pane.ssbound = true;
                if (c.jump)
                    (lazy ? $pane : getItems()).bind(event, function (e) {
                        jump(e, index(e.target));
                    });
                if (nav)
                    nav = $(nav, context).bind(event, function (e) {
                        e.data = Math.round(getItems().length / nav.length) * nav.index(this);
                        jump(e, this);
                    });
                function move(e) {
                    e.data += active;
                    jump(e, this);
                }
                function jump(e, a) {
                    if (isNaN(a)) a = e.data;
                    var n,
                        real = e.type,
                        $items = c.exclude ? getItems().slice(0, -c.exclude) : getItems(),
                        limit = $items.length - 1,
                        elem = $items[a],
                        duration = c.duration;
                    if (real) e.preventDefault();
                    if (auto) {
                        clear();
                        timer = setTimeout(next, c.interval);
                    }
                    if (!elem) {
                        n = a < 0 ? 0 : limit;
                        if (active !== n) a = n;
                        else if (!c.cycle) return;
                        else a = limit - n;
                        elem = $items[a];
                    }
                    if (!elem || (c.lock && $pane._scrollable().is(":animated")) || (real && c.onBefore && c.onBefore(e, elem, $pane, getItems(), a) === false)) return;
                    if (c.stop) $pane._scrollable().stop(true);
                    if (c.constant) duration = Math.abs((duration / step) * (active - a));
                    $pane.scrollTo(elem, duration, c);
                    trigger("notify", a);
                }
                function next() {
                    trigger("next");
                }
                function clear() {
                    clearTimeout(timer);
                }
                function getItems() {
                    return $(items, pane);
                }
                function trigger(a) {
                    $pane.trigger(a + f, [].slice.call(arguments, 1));
                }
                function index(a) {
                    if (!isNaN(a)) return a;
                    var b = getItems(),
                        i;
                    while ((i = b.index(a)) === -1 && a !== pane) a = a.parentNode;
                    return i;
                }
            });
        };
    })(jQuery);
    !(function (a, b) {
        "use strict";
        function c(a) {
            return a && a.toLowerCase ? a.toLowerCase() : a;
        }
        function d(a, b) {
            for (var c = 0, d = a.length; d > c; c++) if (a[c] == b) return !e;
            return e;
        }
        var e = !1,
            f = null,
            g = parseFloat,
            h = Math.min,
            i = /(-?\d+\.?\d*)$/g,
            j = /(\d+\.?\d*)$/g,
            k = [],
            l = [],
            m = function (a) {
                return "string" == typeof a;
            },
            n = function (a, b) {
                for (var c, d = a.length, e = d; e--; ) (c = d - e - 1), b(a[c], c);
            },
            o =
                Array.prototype.indexOf ||
                function (a) {
                    var b = this.length,
                        c = Number(arguments[1]) || 0;
                    for (c = 0 > c ? Math.ceil(c) : Math.floor(c), 0 > c && (c += b); b > c; c++) if (c in this && this[c] === a) return c;
                    return -1;
                };
        (a.tinysort = {
            id: "TinySort",
            version: "1.5.6",
            copyright: "Copyright (c) 2008-2013 Ron Valstar",
            uri: "https://web.archive.org/web/20200512163549/http://tinysort.sjeiti.com/",
            licensed: { MIT: "https://web.archive.org/web/20200512163549/http://www.opensource.org/licenses/mit-license.php", GPL: "https://web.archive.org/web/20200512163549/http://www.gnu.org/licenses/gpl.html" },
            plugin: (function () {
                var a = function (a, b) {
                    k.push(a), l.push(b);
                };
                return (a.indexOf = o), a;
            })(),
            defaults: { order: "asc", attr: f, data: f, useVal: e, place: "start", returns: e, cases: e, forceStrings: e, ignoreDashes: e, sortFunction: f },
        }),
            a.fn.extend({
                tinysort: function () {
                    var p,
                        q,
                        r,
                        s,
                        t = this,
                        u = [],
                        v = [],
                        w = [],
                        x = [],
                        y = 0,
                        z = [],
                        A = [],
                        B = function (a) {
                            n(k, function (b) {
                                b.call(b, a);
                            });
                        },
                        C = function (a, b) {
                            return "string" == typeof b && (a.cases || (b = c(b)), (b = b.replace(/^\s*(.*?)\s*$/i, "$1"))), b;
                        },
                        D = function (a, b) {
                            var c = 0;
                            for (0 !== y && (y = 0); 0 === c && s > y; ) {
                                var d = x[y],
                                    f = d.oSettings,
                                    h = f.ignoreDashes ? j : i;
                                if ((B(f), f.sortFunction)) c = f.sortFunction(a, b);
                                else if ("rand" == f.order) c = Math.random() < 0.5 ? 1 : -1;
                                else {
                                    var k = e,
                                        o = C(f, a.s[y]),
                                        p = C(f, b.s[y]);
                                    if (!f.forceStrings) {
                                        var q = m(o) ? o && o.match(h) : e,
                                            r = m(p) ? p && p.match(h) : e;
                                        if (q && r) {
                                            var t = o.substr(0, o.length - q[0].length),
                                                u = p.substr(0, p.length - r[0].length);
                                            t == u && ((k = !e), (o = g(q[0])), (p = g(r[0])));
                                        }
                                    }
                                    c = d.iAsc * (p > o ? -1 : o > p ? 1 : 0);
                                }
                                n(l, function (a) {
                                    c = a.call(a, k, o, p, c);
                                }),
                                    0 === c && y++;
                            }
                            return c;
                        };
                    for (p = 0, r = arguments.length; r > p; p++) {
                        var E = arguments[p];
                        m(E) ? z.push(E) - 1 > A.length && (A.length = z.length - 1) : A.push(E) > z.length && (z.length = A.length);
                    }
                    for (z.length > A.length && (A.length = z.length), s = z.length, 0 === s && ((s = z.length = 1), A.push({})), p = 0, r = s; r > p; p++) {
                        var F = z[p],
                            G = a.extend({}, a.tinysort.defaults, A[p]),
                            H = !(!F || "" === F),
                            I = H && ":" === F[0];
                        x.push({ sFind: F, oSettings: G, bFind: H, bAttr: !(G.attr === f || "" === G.attr), bData: G.data !== f, bFilter: I, $Filter: I ? t.filter(F) : t, fnSort: G.sortFunction, iAsc: "asc" == G.order ? 1 : -1 });
                    }
                    return (
                        t.each(function (c, d) {
                            var e,
                                f = a(d),
                                g = f.parent().get(0),
                                h = [];
                            for (q = 0; s > q; q++) {
                                var i = x[q],
                                    j = i.bFind ? (i.bFilter ? i.$Filter.filter(d) : f.find(i.sFind)) : f;
                                h.push(i.bData ? j.data(i.oSettings.data) : i.bAttr ? j.attr(i.oSettings.attr) : i.oSettings.useVal ? j.val() : j.text()), e === b && (e = j);
                            }
                            var k = o.call(w, g);
                            0 > k && ((k = w.push(g) - 1), (v[k] = { s: [], n: [] })), e.length > 0 ? v[k].s.push({ s: h, e: f, n: c }) : v[k].n.push({ e: f, n: c });
                        }),
                        n(v, function (a) {
                            a.s.sort(D);
                        }),
                        n(v, function (a) {
                            var b = a.s,
                                c = a.n,
                                f = b.length,
                                g = c.length,
                                i = f + g,
                                j = [],
                                k = i,
                                l = [0, 0];
                            switch (G.place) {
                                case "first":
                                    n(b, function (a) {
                                        k = h(k, a.n);
                                    });
                                    break;
                                case "org":
                                    n(b, function (a) {
                                        j.push(a.n);
                                    });
                                    break;
                                case "end":
                                    k = g;
                                    break;
                                default:
                                    k = 0;
                            }
                            for (p = 0; i > p; p++) {
                                var m = d(j, p) ? !e : p >= k && k + f > p,
                                    o = m ? 0 : 1,
                                    q = (m ? b : c)[l[o]].e;
                                q.parent().append(q), (m || !G.returns) && u.push(q.get(0)), l[o]++;
                            }
                        }),
                        (t.length = 0),
                        Array.prototype.push.apply(t, u),
                        t
                    );
                },
            }),
            (a.fn.TinySort = a.fn.Tinysort = a.fn.tsort = a.fn.tinysort);
    })(jQuery);
    function numberWithCommas(number) {
        var parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }
    jQuery(document).ready(function () {
        jQuery(".shopify-price").each(function () {
            var num = jQuery(this).text();
            var commaNum = numberWithCommas(num);
            jQuery(this).text(commaNum);
        });
    });
    (function ($) {
        $.fn.oreEqualiseHeight = function () {
            var currentTallest = 0,
                currentRowStart = 0,
                rowDivs = new Array(),
                $el,
                topPosition = 0;
            $(this).each(function () {
                $el = $(this);
                $($el).height("auto");
                topPostion = $el.position().top;
                if (currentRowStart != topPostion) {
                    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                        rowDivs[currentDiv].height(currentTallest);
                    }
                    rowDivs.length = 0;
                    currentRowStart = topPostion;
                    currentTallest = $el.height();
                    rowDivs.push($el);
                } else {
                    rowDivs.push($el);
                    currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
                }
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
            });
        };
        function sortProjectsView(selection) {
            $(".view-portfolio > .view-content > div")
                .tsort("div." + selection, { data: "project-title", order: "asc" })
                .children("div")
                .addClass("disabled")
                .end()
                .children("div." + selection)
                .removeClass("disabled");
        }
        Drupal.behaviors.myBehavior = {
            attach: function (context, settings) {
                $.ajax({
                    url: "//web.archive.org/web/20200512163549/http://adeeni-design-galerie.myshopify.com/cart.json",
                    dataType: "jsonp",
                    success: function (data) {
                        $("#my-cart-num").html(data["item_count"]);
                        if (data["item_count"] > 0) {
                            $("#my-cart").show();
                        }
                    },
                    error: function (jxhr, status, err) {
                        console.log("Error, status = " + status + ", err = " + err);
                    },
                });
                $("#block-system-main-menu ul").find("li:first-child").hide();
                $(".view-shopify-products .views-row").each(function () {
                    if ($(this).find(".shopify-add-to-cart-button").hasClass("shopify-out-of-stock-button")) {
                        $(this).addClass("out-of-stock");
                    }
                });
                $("#block-block-8 .node-shop-home.view-mode-compact_teaser").clone().insertAfter(".category-fly-item span:last");
                $("#block-block-8").hover(
                    function () {},
                    function () {
                        $("#block-block-8").removeClass("open");
                    }
                );
                $(".category-fly-item").hover(
                    function () {
                        if ($(window).width() > 1280) {
                            $("#block-block-8").addClass("open");
                        }
                    },
                    function () {}
                );
                $(".category-fly-item").click(function () {
                    $(".category-fly-item .node-shop-home.view-mode-compact_teaser").toggleClass("open");
                });
                $(".productslider .slide").click(function () {
                    $("#full-screen > .img-wrapper img").attr("src", $(this).find("img").attr("src"));
                    $("#full-screen").addClass("open");
                });
                $(".adeeni-search-toggle").click(function () {
                    if ($(window).width() > 1280) {
                        $("#block-views-4232d62b000c849c2e4c8a1efe7570ad").css("left", 12 + $("#block-block-1").width() + $("#block-system-main-menu").width() - ($("#block-system-main-menu").width() - 599) * 0.5);
                        $("#block-views-4232d62b000c849c2e4c8a1efe7570ad").toggleClass("open");
                    }
                });
                $(".close-fs").click(function (e) {
                    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    $("#full-screen").removeClass("open");
                    console.log("close");
                });
                $(".views-field-shopify-product-images > .field-content").each(function () {
                    $img = $(this).find("img");
                    if ($img.width() > $img.height()) {
                        $margin = $(this).height() - $img.height();
                        $img.css("margin-top", $margin / 2);
                    }
                });
                if ($("body").hasClass("page-claudias-world-updates") || $("body").hasClass("page-node-2018")) {
                    var userFeed = new Instafeed({
                        get: "user",
                        userId: "23999103",
                        accessToken: "23999103.a347213.f5889bd5ace949669e2e14353e942435",
                        resolution: "standard_resolution",
                        target: "instafeed-claudia",
                        limit: 60,
                        template:
                            '<div class="insta-row views-row views-row-1 col col-3 tablet-col-half mobile-col-full large-col-2 no-gutter" data-post-date="{{model.created_time}}"><div class="insta-node node-teaser"><div class="first-region"></div><div class="second-region"><div class="insta-caption headline"><div class="headline-wrapper"><a target="_blank" href="{{link}}">{{caption}}</a></div></div><img src="{{image}}" /><a href="{{link}}" target="_blank"></a></div></div></div>',
                        after: function () {
                            if ($("#instafeed-mason").hasClass("adg-done")) {
                                for (var i = 0; i < 40; i++) {
                                    console.log(i);
                                    $("#instafeed-adg")
                                        .find("div")
                                        .first()
                                        .addClass("adg adg-" + i)
                                        .detach()
                                        .appendTo("#instafeed-mason");
                                    $("#instafeed-claudia")
                                        .find("div")
                                        .first()
                                        .addClass("cld cld-" + i)
                                        .detach()
                                        .appendTo("#instafeed-mason");
                                }
                            } else {
                                $("#instafeed-mason").addClass("claudia-done");
                            }
                        },
                    });
                    var galleryFeed = new Instafeed({
                        get: "user",
                        userId: "4687200965",
                        accessToken: "4687200965.1677ed0.a50c52f4685f45d8a9874b6b91fcc7bf",
                        resolution: "standard_resolution",
                        target: "instafeed-adg",
                        limit: 60,
                        template:
                            '<div class="insta-row views-row views-row-1 col col-3 tablet-col-half mobile-col-full large-col-2 no-gutter" data-post-date="{{model.created_time}}"><div class="insta-node node-teaser"><div class="first-region"></div><div class="second-region"><div class="insta-caption headline"><div class="headline-wrapper"><a target="_blank" href="{{link}}">{{caption}}</a></div></div><img src="{{image}}" /><a href="{{link}}" target="_blank"></a></div></div></div>',
                        after: function () {
                            if ($("#instafeed-mason").hasClass("claudia-done")) {
                                for (var i = 0; i < 40; i++) {
                                    console.log(i);
                                    $("#instafeed-adg")
                                        .find("div")
                                        .first()
                                        .addClass("adg adg-" + i)
                                        .detach()
                                        .appendTo("#instafeed-mason");
                                    $("#instafeed-claudia")
                                        .find("div")
                                        .first()
                                        .addClass("cld cld-" + i)
                                        .detach()
                                        .appendTo("#instafeed-mason");
                                }
                            } else {
                                $("#instafeed-mason").addClass("adg-done");
                            }
                        },
                    });
                    userFeed.run();
                    galleryFeed.run();
                }
                $("#menu-btn").click(function () {
                    $("#topbar").toggleClass("open");
                });
                $("#portfolio-type > .button").click(function () {
                    $("#portfolio-type").toggleClass("open");
                });
                $("#portfolio-type > ul > li > a").click(function () {
                    $("#portfolio-type > ul > li > a").removeClass("set");
                    $("#portfolio-type > .button").html($(this).html());
                    $(this).toggleClass("set");
                    $("#portfolio-type").toggleClass("open");
                });
                $(".view-claudia-s-world > .view-content> .views-row").each(function () {
                    $(this).attr("data-post-date", $(this).find(".first-region").html());
                });
                $(".bg-cover").each(function () {
                    $(this).css("background-image", "url(" + $(this).find("img").attr("src") + ")");
                });
                $("#portfolio-type").click(function (e) {
                    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                });
                $(".node-project.disabled a.teaser-link").click(function (e) {
                    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                });
                $(".horizontal-slider").each(function () {
                    if ($(this).find(".slide").length > 1) {
                        $(this).append('<div class="horizontal-slider-nav prev adeeni-icon-left-big" onclick></div><div class="horizontal-slider-nav next adeeni-icon-right-big" onclick></div>');
                    }
                });
                $(".horizontal-slider-show").each(function () {
                    if ($(this).find(".slide").length > 1) {
                        $(this).append('<div class="horizontal-slider-nav prev adeeni-icon-left-big" onclick></div><div class="horizontal-slider-nav next adeeni-icon-right-big" onclick></div>');
                    }
                });
                $("#scroll-to-details").html($("#prj-dtls > h2").html());
                $("#scroll-to-details").click(function (e) {
                    $(window).scrollTo(document.getElementById("prj-dtls"), 800, { offset: -32 });
                });
                // $("#block-views-shopify-products-block-1 .block-title").click(function (e) {
                //     $(window).scrollTo(document.getElementById("block-views-shopify-products-block-1"), 800, { offset: -50 });
                // });
                $("#block-block-7 #shop-home-categories-view > h4").click(function (e) {
                    $(window).scrollTo(document.getElementById("block-block-7"), 800, { offset: -20 });
                });
                $("#shop-designer-block-label").click(function (e) {
                    console.log("clicked label");
                    $(window).scrollTo(document.getElementById("shop-designer-block-label"), 800, { offset: -50 });
                });
                if ($("body").hasClass("node-type-project")) {
                    $(window).scroll(function () {
                        if (window.pageYOffset > 20) {
                            $(".scroll-wrapper").hide();
                        } else {
                            $(".scroll-wrapper").show();
                        }
                    });
                }
                $(".horizontal-slider > .slides")
                    .serialScroll({
                        items: ".slide",
                        prev: ".horizontal-slider-nav.prev",
                        next: ".horizontal-slider-nav.next",
                       // duration: 500,
                        force: false,
                        lock: false,
                        cycle: false,
                        onBefore: function (e, elem, $pane, $items, pos) {
                            $(elem).addClass("active").siblings().removeClass("active");
                            this.offset = $(".slide:eq(" + pos + ")").width() / 2 - $(window).width() / 2;
                            $(".horizontal-slider-nav.prev").add($(".horizontal-slider-nav.next")).fadeIn();
                            if (pos == 0) {
                                $(".horizontal-slider-nav.prev").fadeOut();
                            } else if (pos == $items.length - 1) {
                                $(".horizontal-slider-nav.next").fadeOut();
                            }
                        },
                    })
                    .children()
                    .first()
                    .addClass("active");
                $(".horizontal-slider-show > .slides")
                    .serialScroll({
                        items: ".slide",
                        prev: ".horizontal-slider-nav.prev",
                        next: ".horizontal-slider-nav.next",
                       // duration: 1000,
                        force: false,
                        lock: false,
                        cycle: true,
                       // interval: 1500,
                        step: 1,
                        onBefore: function (e, elem, $pane, $items, pos) {
                            $(elem).addClass("active").siblings().removeClass("active");
                            this.offset = $(".slide:eq(" + pos + ")").width() / 2 - $(window).width() / 2;
                            $(".horizontal-slider-nav.prev").add($(".horizontal-slider-nav.next")).fadeIn();
                            if (pos == 0) {
                                $(".horizontal-slider-nav.prev").fadeOut();
                            } else if (pos == $items.length - 1) {
                                $(".horizontal-slider-nav.next").fadeOut();
                            }
                        },
                    })
                    .children()
                    .first()
                    .addClass("active");
                $("#portfolio-type a.project-type-link").click(function (e) {
                    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    sortProjectsView($(this).attr("rel"));
                });
                if ($(window).width() > 1280) {
                    if ($("body").hasClass("admin-menu")) {
                        $(".node-type-project .horizontal-slider img").css({ height: $(window).height() - $("#topbar").height() - 21, width: "auto" });
                    } else {
                        $(".node-type-project .horizontal-slider img").css({ height: $(window).height() - $("#topbar").height() - 1, width: "auto" });
                    }
                } else {
                    $my_h = $(".node-type-project .horizontal-slider img").parent().parent().parent().parent().parent().parent().height() + "px";
                    console.log($my_h);
                    $(".node-type-project .horizontal-slider img").css({ height: $my_h, width: "auto" });
                }
                if ($(window).width() > 600) {
                    if ($("body").hasClass("admin-menu")) {
                        $("body.node-type-home #content").css({ height: $(window).height() - $("#topbar").height() - 21, width: "auto" });
                    } else {
                        $("body.node-type-home #content").css({ height: $(window).height() - $("#topbar").height() - 1, width: "auto" });
                    }
                }
                $(window).resize(function () {
                    if ($(window).width() > 1280) {
                        if ($("body").hasClass("admin-menu")) {
                            $(".node-type-project .horizontal-slider img").css({ height: $(window).height() - $("#topbar").height() - 21, width: "auto" });
                        } else {
                            $(".node-type-project .horizontal-slider img").css({ height: $(window).height() - $("#topbar").height(), width: "auto" });
                        }
                        if ($("#block-views-4232d62b000c849c2e4c8a1efe7570ad").hasClass("open")) {
                            $("#block-views-4232d62b000c849c2e4c8a1efe7570ad").css("left", 12 + $("#block-block-1").width() + $("#block-system-main-menu").width() - ($("#block-system-main-menu").width() - 599) * 0.5);
                        }
                    } else {
                        $("#block-views-4232d62b000c849c2e4c8a1efe7570ad").css("left", "auto").removeClass("open");
                        $(".node-type-project .horizontal-slider img").css({ height: $(this).parent().height(), width: "auto" });
                    }
                    if ($(window).width() > 600) {
                        if ($("body").hasClass("admin-menu")) {
                            $("body.node-type-home #content").css({ height: $(window).height() - $("#topbar").height() - 21, width: "auto" });
                        } else {
                            $("body.node-type-home #content").css({ height: $(window).height() - $("#topbar").height() - 1, width: "auto" });
                        }
                    } else {
                        $("body.node-type-home #content").css({ height: "auto" });
                    }
                    $(".views-field-shopify-product-images > .field-content").each(function () {
                        $img = $(this).find("img");
                        if ($img.width() > $img.height()) {
                            $margin = $(this).height() - $img.height();
                            $img.css("margin-top", $margin / 2);
                        }
                    });
                });
            },
        };
    })(jQuery);
}
